import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import palette from '../../theme/palette'
import { IWaterSystemWCoordinates, IWellWaterSystemWCoordinates } from '../../types'

interface ICenter {
  lat: number
  lng: number
}

export interface IMapData {
  center: ICenter
  zoom: number
  currentMarker: string // pwsid
}

export interface IPopUpDetail {
  position?: { x: number; y: number }
  details?: IWaterSystemWCoordinates | IWellWaterSystemWCoordinates
  fillColor?: string
  visible?: boolean
  timeout?: number | null
}

export interface MapInitialState {
  data: IMapData
  loading: boolean
  error: string
  success: boolean
  currentMarker: string | null
  popupDetail: IPopUpDetail
  context: ContextEnum
  zoomTransition: { ease: boolean; speed: number; curve: number }
  includeTransient: boolean
}
export enum ContextEnum {
  STATE = 'STATE',
  COUNTY = 'COUNTY',
  REGION = 'REGION',
  AREA = 'AREA',
}
const initialState: MapInitialState = {
  data: {
    center: { lat: 39.8283, lng: -98.5795 },
    zoom: 4,
    currentMarker: '',
  },
  zoomTransition: { ease: true, speed: 5.0, curve: 0.5 },
  loading: false,
  error: '',
  success: false,
  context: ContextEnum.REGION,
  currentMarker: null,
  popupDetail: {
    position: { x: 0, y: 0 },
    details: {} as IWaterSystemWCoordinates | IWellWaterSystemWCoordinates,
    fillColor: palette.primary.main,
    visible: false,
    timeout: 5000,
  },
  includeTransient: false,
}

export const MapSlice = createSlice({
  name: 'mapSlice',
  initialState,
  reducers: {
    setContext: (state, action: PayloadAction<ContextEnum>) => {
      state.context = action.payload
    },
    setMapCenter: (state, action: PayloadAction<ICenter>) => {
      state.data.center = action.payload
    },
    setMapZoom: (state, action: PayloadAction<{ zoom: number; ease?: boolean }>) => {
      state.data.zoom = action.payload.zoom
      state.zoomTransition.ease = action.payload.ease || initialState.zoomTransition.ease
    },
    setCurrentMarker: (state, action: PayloadAction<string>) => {
      state.data.currentMarker = action.payload
    },
    setPopupDetail: (state, action: PayloadAction<IPopUpDetail>) => {
      if (!action.payload.timeout) {
        action.payload.timeout = initialState.popupDetail.timeout
      }
      state.popupDetail = { ...state.popupDetail, ...action.payload }
    },
    resetPopupDetail: (state, action: PayloadAction<IPopUpDetail>) => {
      state.popupDetail = initialState.popupDetail
    },
    setIncludeTransient: (state, action: PayloadAction<boolean>) => {
      state.includeTransient = action.payload
    },
  },
  extraReducers: (builder) => {},
})

export const MapActions = {
  ...MapSlice.actions,
}

export const MapReducer = MapSlice.reducer
